module.exports = __webpack_public_path__ + "static/img/zwsj.155f913a.jpg";